export default "__VITE_ASSET__DWiIgQvZ__"